{ TrelloStorage } = require '@trello/storage'
View = require 'app/scripts/views/internal/view'
templates = require 'app/scripts/views/internal/templates'
{ track } = require '@trello/analytics'

module.exports = class OrganizationLinkGAHelperView extends View
  viewTitleKey: 'link google apps domain'

  events:
    'click .js-link': 'link'

  render: ->
    data = @model.toJSON()

    @$el.html(
      templates.fill(
        require('app/scripts/views/templates/org_link_ga_helper'),
        data,
        { editable: @model.editable() }
      )
    )

    @

  link: ->
    track("Organization View", "Members Page", "Google Apps Marketplace link")

    if TrelloStorage.isEnabled()
      TrelloStorage.set 'idOrganizationLinking', @model.id

    return
